import React from 'react';
import { IconButton } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { KeyboardArrowUp } from '@mui/icons-material';
import MuiTableCell from '@mui/material/TableCell';

const TableCell = withStyles({
  root: {
    borderBottom: 'none',
  },
})(MuiTableCell);

const DummyTableCell = () => {
  return (
    <TableCell>
      <IconButton
        aria-label="expand row"
        size="small"
        onClick={() => {}}
        style={{ opacity: 0 }}
      >
        <KeyboardArrowUp />
      </IconButton>
    </TableCell>
  );
};

export default DummyTableCell;
